/**
 * useDebouncedListingSearch — local search input with debounced query commit.
 *
 * A6 from listing-abstraction-opportunities.md
 *
 * Maintains a local input value that updates immediately for UX responsiveness
 * while debouncing the actual query update (setSearch). Cancels on unmount.
 */
import { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
export function useDebouncedListingSearch({ setSearch, onNarrow, delayMs = 300 }) {
    const [searchInput, setSearchInput] = useState('');
    const debouncedSetSearch = useMemo(() => debounce((value) => {
        setSearch(value);
        onNarrow === null || onNarrow === void 0 ? void 0 : onNarrow();
    }, delayMs), [setSearch, onNarrow, delayMs]);
    // Cancel pending debounce on unmount to avoid state updates on dead component.
    useEffect(() => () => debouncedSetSearch.cancel(), [debouncedSetSearch]);
    const handleSearchChange = useCallback((value) => {
        setSearchInput(value);
        debouncedSetSearch(value);
    }, [debouncedSetSearch]);
    return { searchInput, handleSearchChange };
}
